export class VariableI{
    id : number;
    idvarparam : number;
    codigo : string;
    nombre : string;
    descrip : String;
    codsuper : String;
}